var React = require('react');

function BloodDropTan (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.3996 0.147451L0.807111 5.36997C0.340623 6.04826 0.0403547 6.83646 0.00282121 7.65683C-0.0373933 8.62466 0.241427 9.59249 0.855368 10.378C1.54974 11.2708 2.7106 12 4.63821 12C6.56582 12 7.72668 11.2708 8.42105 10.378C9.03499 9.59249 9.31381 8.62466 9.2736 7.65683C9.23875 6.83378 8.9358 6.04826 8.46931 5.36997L4.8795 0.147451C4.7803 -0.0509406 4.4988 -0.0509406 4.3996 0.147451Z","fill":"#69102C"}));
}

BloodDropTan.defaultProps = {"width":"10","height":"12","viewBox":"0 0 10 12","fill":"none"};

module.exports = BloodDropTan;

BloodDropTan.default = BloodDropTan;
